import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { onActivated, reactive, toRefs } from "vue";
import apis from "@/api";
import { useRouter } from 'vue-router';
import download from "@/utils/download";
import { srcType } from "@/utils/srcType";
export default {
  props: {
    id: String
  },
  setup(props, ctx) {
    const {
      singleDownload
    } = download();
    let data = reactive({
      bodyStyle: {
        'background-color': '#E9EEF3',
        'padding': '5px 10px 5px 10px'
      },
      posBizInfo: {
        assetBaseInfo: {},
        assetsPosNames: [],
        positionBizDownList: [],
        unDownAreaNameList: []
      },
      srcType: srcType,
      isDownloading: false
    });
    const loadData = id => {
      apis.queryOffLPosBizById(id).then(res => {
        // console.log(res,"queryOffLPosBizById")
        if (res.success) {
          data.posBizInfo = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const route = useRouter();
    onActivated(() => {
      let id = route.currentRoute.value.query.id;
      if (id) {
        loadData(id);
      }
    });
    const downAsset = () => {
      data.isDownloading = true;
      singleDownload(data.posBizInfo.assetBaseInfo.id, data.posBizInfo.assetBaseInfo.assetsName).then(() => {
        data.isDownloading = false;
      }).finally(() => {
        data.isDownloading = false;
      });
    };
    return {
      ...toRefs(data),
      loadData,
      downAsset,
      singleDownload
    };
  }
};